import en from './products_admin.en';

const enConfig = { en };

export default enConfig;
